<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜尋 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
                    <el-row  :gutter="20" >
						<el-col :span="12" :xs="12">
							<el-tag type="success">增加：{{total_list.total_yes}}</el-tag>
						</el-col>
						<el-col :span="12"  :xs="12">
							<el-tag type="danger" >扣除：{{total_list.total_no}}</el-tag>
						</el-col>
						
					</el-row>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="用戶名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="用戶名稱"></el-input>
						</el-form-item>

						<el-form-item label="用戶編號" class="mb-0">
							<el-input size="small" v-model="from.user_no" placeholder="用戶編號"></el-input>
						</el-form-item>
						
						
						<el-form-item label="時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item label="類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="每日任務獲取" :value="1"></el-option>
								<el-option label="升級獲取" :value="2"></el-option>
								<el-option label="報名抵扣" :value="3"></el-option>
								<el-option label="報名返還" :value="4"></el-option>
								<el-option label="郵件禮物獲取" :value="5"></el-option>
								<el-option label="後台操作" :value="6"></el-option>
							</el-select>
						</el-form-item>

                        <el-form-item label="操作類型" class="mb-0">
							<el-select v-model="from.is_add" size="small" placeholder="請選擇查看操作類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="增加" :value="1"></el-option>
								<el-option label="扣除" :value="0"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column align="center"  prop="user_no" label="用戶編號">
				</el-table-column>

				<el-table-column align="center"  prop="name" label="用戶名稱">
				</el-table-column>
					
				<el-table-column align="center" prop="type_name" label="類型">
				</el-table-column>

				<el-table-column align="center" label="關聯信息">
					<template slot-scope="v">
						{{v.row.operate_name}}
						<span v-if="v.row.operate">
							- <el-tag type="success" >{{ v.row.operate }}</el-tag>
						</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="is_add" label="操作類型">
                    <template slot-scope="v">
						<span>
							<el-tag type="success" v-if="v.row.is_add == 1">增加</el-tag>
							<el-tag type="danger" v-else>扣除</el-tag>
						</span>
					</template>
				</el-table-column>
				
                <el-table-column align="center" prop="num" width="200" label="數量">
                    <template slot-scope="v">
						<span class="text-success" style="font-weight: 700;" v-if="v.row.is_add == 1">{{v.row.num}}（{{v.row.balance}}）</span>
						<span class="text-danger" style="font-weight: 700;" v-else>{{v.row.num}}（{{v.row.balance}}）</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="create_time" width="200" label="時間">
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

	
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				createModelInfo: false,
				editIndex: -1,
                type:3,
				//搜索數据
				from: {
					name: '',
					user_no: '',
					is_add: -1,
					type: -1,
					time: [],
				},
				model_title: 'UserTopic',
				auth_val: 'UserTopic',
				preUrl: "user/coinList", //列表地址
				delAllUrl: "data/delUserEmailAll", //批量删除地址
				delUrl: "data/delUserEmail", //删除單条地址
                editStatusUrl: "data/editStatusUserEmail", //修改狀態地址

				tableData: [],
				
				prop: 'id',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				
                dialog_list:[],
                dialog_difficulty_list:[],
                dialog_label_list:[],
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			// this.commonList(['subject_list','grade_list']);
		},
		methods: {
			tableRowClassName({row, rowIndex}) {
				if (row.status === 0) {
				return 'warning-row';
				} else if (row.status === 1) {
				return 'success-row';
				}
				return 'danger-row';
			},
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			 // 顯示完整題目内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogVisible = true;
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.grade_list = list.grade
					this.subject_list = list.subject

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
		
		
			// 打开模态框
			openModel(e) {
                this.layout.loading = true;
				this.axios.post('/admin/data/getTopicList', {
					id: e,
				}, {
					token: true,
				}).then(res => {
					let all = res.data.data
                    this.dialog_list = all.list;

                    // // 打开dialog
                    this.createModel = true
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},

			// 打开模态框
			openModelInfo(e) {
                this.layout.loading = true;
				this.axios.post('/admin/data/getTopicInfo', {
					id: e,
				}, {
					token: true,
				}).then(res => {
					let all = res.data.data
                    this.dialog_difficulty_list = all.list.difficulty;
                    this.dialog_label_list = all.list.label;

                    // // 打开dialog
                    this.createModelInfo = true
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},


			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
			},
			// 清空篩選條件
                clearSearch() {
				this.from = {
                    name:'',
					user_no: '',
					is_add: -1,
					type: -1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>


<style>
 .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .el-table .danger-row {
    background: rgb(253, 226, 226)
  }

  .is-disabled {
	cursor: not-allowed;  /* 禁止光標样式 */
	color: #c0c4cc;       /* 灰色文字 */
	background-color: #f5f7fa; /* 灰色背景 */
  }
</style>
